import { PartnerType } from "./PartnerType";
export class PartnerTypeFeaturesPermission {
    Id: number | null;
    Tenant: number;
    PartnerTypeCode: string;
    PartnerType: PartnerType;
    FeatureCode: string;
    FeatureName: string;
    Display: boolean;
}